/**
 * RSE — accordéon vertical (un seul panneau ouvert à la fois).
 */
(function () {
  'use strict';

  var accordion = document.querySelector('.rse__accordion');
  if (!accordion) return;

  var items = accordion.querySelectorAll('.rse-accordion__item');
  if (!items.length) return;

  function closeItem(item) {
    var trigger = item.querySelector('.rse-accordion__trigger');
    var panel = item.querySelector('.rse-accordion__panel');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
  }

  function openItem(item) {
    var trigger = item.querySelector('.rse-accordion__trigger');
    var panel = item.querySelector('.rse-accordion__panel');
    if (!trigger || !panel) return;
    trigger.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
  }

  function closeAll() {
    for (var i = 0; i < items.length; i++) closeItem(items[i]);
  }

  for (var j = 0; j < items.length; j++) {
    (function (item) {
      var trigger = item.querySelector('.rse-accordion__trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        closeAll();
        if (!isOpen) openItem(item);
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    })(items[j]);
  }
})();